<template>
	<div class="tab-pane fade show active position-relative" id="details" role="tabpanel" aria-labelledby="details-tab">
	    <div v-bind:class="{ open: !uiStates.addPriceProfile && uiStates.activeModal == 'relationAttributes' , 'is-loading': uiStates.showLoading  }" class="slider-modal">
            <transition name="vue-table-loader">
                <div class="vue-details-loader alt" v-if="uiStates.showLoading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
            </transition>
            <transition name="fade">
                <div class="container"  v-if="uiStates.activeModal == 'relationAttributes'">
                    <a v-on:click="closeAttributesModal()"  class="close-section">&times;</a>
                    <div class="slider-modal-copy">
                        <div class="attributes-container">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>{{visibleModalFields.name}}</h3>
                                </div>
                            </div>
                            <input-loader :fields="visibleModalFields.attributes"></input-loader>
                            <div class="row">
                                <div class="col-md-12 text-right">
                                    <button type="button" class="btn btn-secondary" @click="closeAttributesModal()">Cancel</button>
                                    <button type="button" class="btn btn-primary" @click="savePriceProfileAttributes(visibleModalFields)">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
		
		<transition name="vue-table-loader">
	        <div class="vue-table-loader" v-if="loading"><span class="fa fa-cog fa-spin fa-3x"></span></div>
	    </transition>

		<div class="product-form-tab">
			<div class="row">
				<div class="col-md-6">
					<h3 class="pt-2 mb-2">Pricing Profiles</h3>
					<p class="text-muted mb-2 text-xs max-w-para">
							Pricing Profiles are a BigCommerce-specific feature for handling bulk pricing. To learn more
							<a href="https://jasperpim.atlassian.net/wiki/spaces/JPKB/pages/47742977/How+to+push+to+BigCommerce+bulk+pricing">
							click here</a>.
					</p>
				</div>
				<div class="col-md-6 text-right">
					<a v-if="$parent.permissionAllowed('price_profile_create') && !uiStates.addPriceProfile" href="/pricing-profiles"  class="btn btn-primary">Create</a>
					<a v-if="$parent.permissionAllowed('product_price_profile_create') && !uiStates.addPriceProfile" @click="addPriceProfile()"  class="btn btn-primary">Add Existing</a>
				</div>
			</div>
			<div v-if="$parent.permissionAllowed('product_price_profile_create') && uiStates.addPriceProfile" id="adjust_relationship" class="pl-4 pr-4 mb-3">

				
                <!-- if there are no relations provide a link to the create relation type -->
                <select-item-from-api-provided-list
                    :api="'pimapi/products_pricing_profiles/' + this.productId + '/unlinked'"
					apiType="grid"
                    :columns="['name', 'price_base', 'priority']"
                    list-label="Select a Pricing Profile"
					@selection="handlePriceProfileSelected"
                >
                </select-item-from-api-provided-list>

                <div class="apply-new-relationship">
                    <a v-on:click.prevent="postPriceProfile()" :class="{disabled: !selectedPriceProfile}" href="#" class="btn btn-primary mr-1">Add Pricing Profile</a>
                    <a v-on:click.prevent="cancelAddPriceProfile()" href="#" class="btn btn-secondary">Close</a>
                </div>
            </div>
            <form action="" v-if="!uiStates.addPriceProfile">
                <div class="form-element-container">
                    <div class="row">
                        <div class="col-md-12 clearfix">
                            <div  v-if="productPriceProfiles">
                                <div class="collapse-container"  v-if="productPriceProfiles.length != 0">
                                    <a v-if="uiStates.collapsePanelToggle" class="view-collapse-all" href="#" v-on:click="collapseAll()">
                                        Collapse All
                                    </a>
                                    <a v-else class="view-collapse-all" href="#" v-on:click="expandAll()">
                                        Expand All
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
					<template v-for="(profilesByBase, base) in productPriceProfiles">
						<span class="ml-2"><b>{{base}}</b></span>
						<div  v-for="(priceProfile, name) in profilesByBase" :id="'atributeAccordion'+name" class="group-continer" :key="base + '_profile_' + name">
                            <div class="" id="headingOne">
								<div class="group-name">
									<a href="#" data-toggle="collapse" :data-target="'#attributeCollapse-'+name" aria-expanded="true" :aria-controls="'attributeCollapse-'+name">
										{{priceProfile.profile.name }} <span  v-if="priceProfile.concrete_entity !== null" class="ml-2 badge badge-secondary">{{ priceProfile.concrete_entity.name}}</span>
									</a>
									<div class="pull-right mr-4">
										<a v-if="priceProfile.reference === null && $parent.permissionAllowed('product_price_profile_delete')" class="btn btn-sm btn-danger" @click="deletePriceProfile(priceProfile.profile.id)">Remove</a>
										<a v-if="$parent.permissionAllowed('product_price_profile_update') && priceProfile.priority > profilesByBase.minPriority" @click="prioritize(priceProfile)" class="btn btn-sm btn-primary">Prioritize</a>
										<a href="#" v-on:click.prevent="loadAttributesModal(priceProfile)" class="btn btn-sm btn-outline-primary">
											<span>Attributes</span>
										</a>
									</div>
								</div>
                            </div>
                            <div :id="'attributeCollapse-'+name" class="collapse show" aria-labelledby="headingOne" :data-parent="'#atributeAccordion'+name">
                                <div>
                                    <div class="ml-0">
										<vuetable ref="vuetable"
											:api-mode="false"
  											:data="priceProfile.profile.tiers"
											:fields="fields"
											:css="css.table"
											noDataTemplate="No Price Profile Tiers Found"
										>
										</vuetable>
                                    </div>
                                </div>
                            </div>
                        </div>
					</template>
                    <!-- <template v-for="(priceProfile, name) in profilesByPriority">
                        
                    </template> -->
                </div>
            </form>
        </div>
	</div>
</template>

<style lang="scss">
    @import "~easymde/dist/easymde.min.css";
    @import "~vue-codemirror/node_modules/codemirror/addon/lint/lint.css";
    .CodeMirror {
        padding: 0px;
    }
</style>

<style scoped lang="scss">

.attribute-label {
    text-align: right;
    line-height: 1.3em;
}
.heading-container{
    margin-bottom: 20px;
}
.group-continer{
    margin-bottom:30px;
}
.group-name{
    position: relative;
    padding: 10px;
    display: block;
    font-size: 14px;
    color: #586670;
    border: 1px solid #dedede;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    background-color: #f5f6fa;
    &:before{
        content: "\F110";
        font: normal normal normal 12px/1 "LineAwesome";
        position: absolute;
        right: 10px;
        top: 14px;
        transform: rotate(-180deg);
    }
    &.collapsed{
        border-bottom-right-radius: 5px;
        border-bottom-left-radius: 5px;
        &:before{
            content: "\F110";
            font: normal normal normal 12px/1 "LineAwesome";
            transform: rotate(0deg);
        }
    }
}
.group-body{
    border-left: 1px solid #dedede;
    padding: 10px 10px 0px 10px;
    border-right: 1px solid #dedede;
    border-bottom: 1px solid #dedede;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
}
.view-collapse-all{
    position: absolute;
    color:#3191FF;
    right: 15px;
}
.alert{
    overflow:hidden;
    padding: 9px 20px;
    &.alert-info{
        color: #0c7b94 !important;
        border-color: #02a7cd !important;
        background: rgba(206, 245, 255, 0.7) !important;
    }
    &.alert-danger{
        color: #581c21 !important;
        border-color: #f1d2cc !important;
        background: #fbeaec !important;
    }
    &.alert-warning{
        color: #856404;
        background-color: #fff3cd;
        border-color: #f1e1b1;
    }
}
</style>


<script type="text/javascript">

	var base_url = window.location.protocol + "//" + window.location.host

	import Vue from 'vue';
	import VueEvents from 'vue-events'
	import * as Vuetable from 'vuetable-2';
	import moment from 'moment';
	import BaseFilterBar from '../tables/base-filter-bar.vue';
	import PaginationLimit from '../generic/tables/pagination-limit.vue';
	import BasePagination from '../tables/base-pagination.vue';
	import BasePaginationInfo from '../tables/base-pagination-info.vue';
	import BaseSelectVisible from '../tables/base-select-visible.vue';
	import TableSearch from '../generic/tables/search.vue';
	import SelectItemFromApiProvidedList from '../generic/select-item-from-api-provided-list.vue';
	import InputLoader from "../form/form-loader.vue";
	import Axios from 'axios';

	Vue.use(VueEvents)

	export default {
	    name: 'product-pricing-profiles',
	    props: ['title', 'endpoint'],
	    components:{
	     	'base-filter-bar': BaseFilterBar,
	     	'base-pagination': BasePagination,
	     	'base-pagination-info': BasePaginationInfo,
	     	'base-select-visible': BaseSelectVisible,
			'table-search' : TableSearch,
			'pagination-limit' : PaginationLimit,
			'select-item-from-api-provided-list': SelectItemFromApiProvidedList,
			"input-loader": InputLoader,
	    },
	    data() {
	    	return {
				selectedPriceProfile: null,
				lowerPriority: 1,
				productPriceProfiles: [],
				uiStates: {
                    errorMessage: null,
                    showLoading: false,
                    collapsePanelToggle: true,
					addPriceProfile: false,
					activeModal: null
                },
	    		perPage: 10,
	    		moreParams: {},
	    		loading: true,
				fields: [
					{
						name: 'name',
					},
					{
						title: 'Minimum Quantity',
						name: 'minimum_qty'
					},
					{
						title: 'Customer Discount %',
						name: 'cost',
					},
					{
						title: 'Customer Price w/ Discount',
						name: 'finalCost',
						formatter (value) {
							return value ? value : '-'
						}
					},
					{
						title: 'Discount %',
						name: 'amount',
					},
					{
						
						title: 'Price w/ Discount',
						name: 'finalPrice',
						formatter (value) {
							return value ? value : '-'
						}
					},
				],
				amountsShown: [
					{ text: '10', value: 10 },
					{ text: '25', value: 25 },
					{ text: '50', value: 50 },
					{ text: '100', value: 100 }
				],
				grid: this.title == "All" ? (base_url + "/" + this.endpoint + "/grid") : (base_url + "/" + this.endpoint + "/" + this.productId + "/grid"),
				css: {
					table: {
						tableClass: 'table table-striped table-bordered table-middle',
						ascendingIcon: 'sort-icon-asc',
						descendingIcon: 'sort-icon-desc',
						infoClass: '',
					},
				},
			}
	    },
	    async mounted() {
	    	this.$events.$on('per-page', eventData => this.doVisibleSet(eventData))
           	this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))
           	this.$events.$on('filter-reset', e => this.onFilterReset())
			
			await this.getProductPriceProfiles();
			this.onLoaded();
	    },
	    watch: {
			'perPage' (val, oldVal) {
		      this.$nextTick(function() {
		        	this.$refs.vuetable.refresh()
		      })
		    },
	    },
		computed: {
			profilesByPriority() {
				return this.productPriceProfiles.sort(function (a, b) {
					return a.priority - b.priority;
				});
			},
			productId() {
				return this.$parent.product.info.id;
			}
		},
	    methods: {
			savePriceProfileAttributes(priceProfileAttributes) {
				this.uiStates.showLoading = true;
				Axios.post(
						base_url +
							"/pimapi/products_pricing_profiles/" +
							this.$parent.product.info.id +
							'/' + priceProfileAttributes.productPriceProfileId  +
							"/updateAttributes",
						{
							profileAttributes: priceProfileAttributes.attributes
						}
					)
					.then(
						function(response) {
							this.uiStates.activeModal = null;
							this.uiStates.showLoading = false;
							this.$parent.alert.status = "alert-success";
							this.$parent.alert.message =
								"Price Profile attributes successfully saved.";
						}.bind(this)
					)
					.catch(
						function(error) {
							this.uiStates.showLoading = false;
							this.$parent.alert.status = "alert-danger";
							this.$parent.alert.message = error.response.data.message;
						}.bind(this)
					);
			},
			loadAttributesModal(priceProfile) {
				if (this.uiStates.activeModal === "relationAttributes") {
					this.closeAttributesModal();
				} else {
					this.visibleModalFields = {
						productPriceProfileId: priceProfile.id, 
						name: priceProfile.profile.name,
						attributes: priceProfile.attributes
					}; // priceProfileId;
					this.uiStates.activeModal = "relationAttributes";
				}
			},
			closeAttributesModal() {
				this.visibleModalFields = {
					name: "",
					attributes: []
				};
				this.uiStates.activeModal = "";
			},
			async getProductPriceProfiles() {
				return await Axios.get('/pimapi/products_pricing_profiles/'+ this.productId).then(r => {
					for (const [key, value] of Object.entries(r.data)) {
						r.data[key].minPriority = Math.min(...value.map(pp => pp.priority));
					}
					this.productPriceProfiles = r.data;
				});
			},
			async prioritize(productPriceProfile) {
				showProcessing();

				await Axios.post('/pimapi/products_pricing_profiles/' +  this.productId + '/' + productPriceProfile.id + '/updatePriority').then(r => {
						this.showwPriorityMessage();
						this.getProductPriceProfiles().then(r => hideProcessing());
					},
					r => {
						if (r.response.data) {
							this.showError(r.response.data.message[0]);
						}
						else {
							this.showError();
						}
						hideProcessing();
					}
				);
				
			},
			cancelAddPriceProfile() {
				this.uiStates.addPriceProfile = false
				this.selectedPriceProfile = null;
			},
			async postPriceProfile(){
				showProcessing();

				await Axios.post('/pimapi/products_pricing_profiles/' +  this.productId, { 'price-profile': this.selectedPriceProfile }).then(r => {
						this.uiStates.addPriceProfile = false;
						this.showwLinkedMessage();
						this.getProductPriceProfiles().then(r => hideProcessing());
					},
					r => {
						if (r.response.data) {
							this.showError(r.response.data.message[0]);
						}
						else {
							this.showError();
						}
						hideProcessing();
					}
				);
			},
			async deletePriceProfile(priceProfileId){
				showProcessing();

				await Axios.delete('/pimapi/products_pricing_profiles/' +  this.productId + '/' +  priceProfileId).then(r => {
						this.showwUnlinkedMessage();
						this.getProductPriceProfiles().then(r => hideProcessing());
					},
					r => {
						if (r.response.data) {
							this.showError(r.response.data.message[0]);
						}
						else {
							this.showError();
						}
						hideProcessing();
					}
				);
			},
			showError(msg){
				if(!msg) {
					msg = "Unexpected error has occured. Plase try again later";
				}
				this.$parent.alert.status = "alert-danger";
				this.$parent.alert.message = msg;
			},
			handlePriceProfileSelected(item){
				this.selectedPriceProfile = item;
			},
			addPriceProfile(){
				this.uiStates.addPriceProfile = true;
			},
			collapseAll() {
                this.uiStates.collapsePanelToggle = !this.uiStates.collapsePanelToggle;

                $('.group-continer .collapse').collapse('hide')
            },
            expandAll() {
                this.uiStates.collapsePanelToggle = !this.uiStates.collapsePanelToggle;

                $('.group-continer .collapse').collapse('show')
            },
			showwPriorityMessage() {
				this.$parent.alert.status = "alert-success";
				this.$parent.alert.message = 'Pricing Profiles priority updated'
			},
			showwLinkedMessage() {
				this.$parent.alert.status = "alert-success";
				this.$parent.alert.message = 'Pricing Profiles linked'
			},
			showwUnlinkedMessage() {
				this.$parent.alert.status = "alert-danger";
				this.$parent.alert.message = 'Pricing Profiles removed'
			},
	        doVisibleSet (perPageValue) {
                this.perPage = perPageValue;
                Vue.nextTick( () => this.$refs.vuetable.refresh())
            },
	        onFilterSet (filterText) {
                this.moreParams = {
                    'filter': filterText
                }
                Vue.nextTick( () => this.$refs.vuetable.refresh())
            },
            onFilterReset () {
                this.moreParams = {}
                Vue.nextTick( () => this.$refs.vuetable.refresh())
            },
			editUrl(id){
                return route('pricing-profiles.edit', id);
            },
            deleteUrl(id) {
                return route('pricing-profiles.destroy', id);
            },
            onLoaded: function () {
                this.loading = false;
            }
		}
	};
</script>
